import { render, staticRenderFns } from "./SubscriptionItemView.vue?vue&type=template&id=27bdb302&scoped=true&"
import script from "./SubscriptionItemView.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionItemView.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionItemView.vue?vue&type=style&index=0&id=27bdb302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bdb302",
  null
  
)

export default component.exports